import { MenuProps } from 'antd';
import { Icon } from 'components/shared/Atoms';
import { Link } from 'react-router-dom';
import { CURRENT_PLATFORM } from 'utils/config';
import { useLanguage } from 'hooks/Language/useLanguage';
import {
  SettingOutlined,
  LogoutOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import urls from 'routes/urls';
import { Home, LogOut, SquareUser, WalletCards } from 'lucide-react';

export interface HeaderBarParameterProps {
  loadLogout?: boolean;
  onHandleLogout?: () => void;
}

export const itemsLeftSide = (): MenuProps['items'] => {
  const { translate } = useLanguage();
  const items: MenuProps['items'] = [
    {
      label: <Link to="">{translate('Transfer money')}</Link>,
      key: '1',
      icon: <Icon name="transfer" />,
    },
    {
      label: <Link to="">{translate('Withdraw money')}</Link>,
      key: '2',
      icon: <Icon name="withdraw" />,
    },
    {
      label: <Link to="">{translate('Quick pay')}</Link>,
      key: '3',
      icon: <Icon name="quick-pay" />,
    },
    {
      label: <Link to="">{translate('Get paid')}</Link>,
      key: '4',
      icon: <Icon name="get-paid" />,
    },
    {
      label: <Link to="">{translate('Send cash')}</Link>,
      key: '5',
      icon: <Icon name="send-cash" />,
    },
    {
      label: <Link to="">{translate('Send voucher')}</Link>,
      key: '6',
      icon: <Icon name="gift" />,
    },
  ];
  return items;
};

export const itemsRightSide = (): MenuProps['items'] => {
  const { translate } = useLanguage();
  const items: MenuProps['items'] = [
    {
      label: <Link to="">{translate('Home')}</Link>,
      key: '1',
      icon: <Icon name="home" />,
    },
    {
      label: <Link to="">{translate('Profile')}</Link>,
      key: '2',
      icon: <Icon name="setting" />,
    },
    {
      label: <Link to="">{translate('Marketplace')}</Link>,
      key: '3',
      icon: <Icon name="merchant" />,
    },
    {
      label: <Link to="">{translate('My wallets')}</Link>,
      key: '4',
      icon: <Icon name="wallet" />,
    },
    {
      label: (
        <Link to="">
          {CURRENT_PLATFORM.toUpperCase()}
          {translate(' & I')}
        </Link>
      ),
      key: '5',
      icon: <Icon name="send-cash" />,
    },
    {
      label: <Link to="">{translate('Logout')}</Link>,
      key: '6',
      icon: <Icon name="logout" />,
    },
  ];
  return items;
};

export const agbDropdownItems = (
  loadLogout: boolean | undefined,
  onHandleLogout?: () => void,
): MenuProps['items'] => {
  const { translate } = useLanguage();
  const items: MenuProps['items'] = [
    {
      label: <Link to={urls.dashboard}>{translate('Home')}</Link>,
      key: '1',
      icon: <Home strokeWidth={1} />,
    },
    {
      label: (
        <Link to={urls.userProfile}>{translate('Profile')}</Link>
      ),
      key: '2',
      icon: <SquareUser strokeWidth={1} />,
    },

    {
      label: (
        <Link to={urls.accounts}>{translate('My Accounts')}</Link>
      ),
      key: '3',
      icon: <WalletCards strokeWidth={1} />,
    },
    {
      label: (
        <Link to="" type="text" onClick={onHandleLogout}>
          {translate('Logout')}
        </Link>
      ),
      key: '4',
      icon: !loadLogout ? (
        <LogOut strokeWidth={1} />
      ) : (
        <LoadingOutlined />
      ),
    },
  ];
  return items;
};
